import { getImageDimensionsFromFile } from "../../../../utils/image-dimensions";
import { resizeImageProportionally } from "../../../../utils/resize-image";

const DIMS = {
  small: { height: 800, width: 1200 },
  large: { height: 2048, width: 2048 },
};

export async function downSampleImage(file: File, maxSize: keyof typeof DIMS): Promise<File> {
  try {
    const dims = await getImageDimensionsFromFile(file);

    const maxDims = DIMS[maxSize];

    if (dims.height < maxDims.height && dims.width < maxDims.width) return file;

    return await resizeImageProportionally(file, {
      maxHeight: maxDims.height,
      maxWidth: maxDims.width,
    });
  } catch (e) {
    console.error(e);
    return file;
  }
}
